// extracted by mini-css-extract-plugin
module.exports = {"Xs":"Xs--11YpR","Sm":"Sm--6Bkb8","Md":"Md--kwDBK","Lg":"Lg--2ZX-i","Xl":"Xl--317bl","Xxl":"Xxl--3ODEV"};